import TranslationText from '@Components/Utilities/TranslationText';

const FeaturedSellerAuctionDate = (props) => {

    // Convert AuctionDate to desired format
    const formattedAuctionDate = new Date(props.AuctionDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    // Add class to upcoming-table if sale is today
    const upcomingTableClass = `upcoming-table ${props.IsSaleToday ? 'sale-is-today' : ''}`;

    return (
        <div className={upcomingTableClass}>
            <div className="upcoming-title">
                <h2>
                    <a href={props.UpcomingAuctionSingleDateURL}>{formattedAuctionDate} </a>
                    <div className="event-count">{props.ListingCount} <TranslationText tKey='sandhills.itemsonauction' /></div>
                </h2>
            </div>
            <div className="upcoming-row">
                <h3><TranslationText tKey='sandhills.featuredsellers' />:</h3>
                <ul>
                    {props.FeaturedSellers.map((vmSeller) => {
                        return (
                            <li key={vmSeller.LinkURL}>
                                <a href={vmSeller.LinkURL}>
                                    <div className="upcoming-seller">
                                        <strong>{vmSeller.DealerDisplayName}</strong>
                                        {vmSeller.DealerDisplayLocation}
                                    </div>
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
            {props.Sellers.length > 0 && (
                <div className="upcoming-more">
                    <div className="upcoming-row">
                        <h3><TranslationText tKey='sandhills.allsellers' />:</h3>
                        <ul>
                            {props.Sellers.map((Seller) => {
                                return (
                                    <li key={Seller.LinkURL}>
                                        <a href={Seller.LinkURL}>
                                            <div className="upcoming-seller">
                                                <strong>{Seller.DealerDisplayName}</strong>
                                                {Seller.DealerDisplayLocation}
                                            </div>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                    <a className="view-sellers">
                        <div className="seller-icon"><i className="fas fa-plus-circle" aria-hidden="true"></i></div>
                        <div className="seller-text"><TranslationText tKey='sandhills.viewallsellers' /></div>
                    </a>
                </div>
            )}
        </div>
    );
};

export default FeaturedSellerAuctionDate;
